module.exports = __webpack_public_path__ + "res/31-img_timer.a4f8f6d32fbe6b310063bfdb0b589a08.png";